import React from "react";
import { RequiredMarker } from "@shared/components";

import "./index.scss";

interface LabelProps {
  title: string;
  className?: string;
  isRequired?: boolean;
  // 923-core-context context/engineering/spark-rewards/phase-56-drawer-follow-ups.md #2: links this label to its control (e.g. Textarea's generated/explicit
  // id) so it actually becomes the control's accessible name -- optional, every existing caller that
  // doesn't pass it keeps rendering the same unlinked `<label>` as before.
  htmlFor?: string;
}

const Label = (props: LabelProps) => {
  const { title, className, isRequired, htmlFor } = props;

  return (
    <label className={className} htmlFor={htmlFor}>
      {isRequired && <RequiredMarker />}
      {title}
    </label>
  );
};

export default Label;
